import { Link } from 'react-router-dom';

export default function Support() {
  return (
    <section className="section">
      <div className="container">
        <div className="support-hero p-4 p-md-5" data-aos="zoom-in">
          <div className="row align-items-center justify-content-center gy-5">

            <div className="col-lg-6 text-center text-lg-start">
              <i className="bi bi-headset" style={{ fontSize: '2.5rem', color: '#fff' }}></i>
              <h1 className="fw-900 mt-3" style={{ color: '#fff' }}>Demandes de support</h1>
              <p className="mt-3" style={{ color: 'rgba(255,255,255,.9)', maxWidth: '520px' }}>
                Bénéficiez d'un support technique rapide et performant, propulsé par Atera
                et l'intelligence artificielle. Notre équipe est disponible pour répondre à
                vos demandes, à distance ou sur site.
              </p>
              <div className="mt-4">
                <Link
                  to="/contact"
                  className="btn btn-lg rounded-pill px-5"
                  style={{
                    background: '#fff',
                    color: 'var(--cpuc-red)',
                    fontWeight: 700,
                    boxShadow: '0 0 0 3px rgba(255,255,255,0.25), 0 8px 24px rgba(0,0,0,0.25)',
                    transition: 'box-shadow 0.25s ease, transform 0.2s ease',
                  }}
                  onMouseEnter={e => {
                    e.currentTarget.style.boxShadow = '0 0 0 5px rgba(255,255,255,0.45), 0 12px 32px rgba(0,0,0,0.35)';
                    e.currentTarget.style.transform = 'translateY(-2px)';
                  }}
                  onMouseLeave={e => {
                    e.currentTarget.style.boxShadow = '0 0 0 3px rgba(255,255,255,0.25), 0 8px 24px rgba(0,0,0,0.25)';
                    e.currentTarget.style.transform = 'translateY(0)';
                  }}
                >
                  Ouvrir un billet
                </Link>
              </div>
            </div>

            <div className="col-lg-4 text-center">
              <svg
                width="100%"
                viewBox="0 0 240 100"
                xmlns="http://www.w3.org/2000/svg"
                style={{ maxWidth: '260px', marginBottom: '1.25rem' }}
                aria-hidden="true"
              >
                <rect x="4" y="4" width="88" height="58" rx="6" fill="rgba(255,255,255,0.12)" stroke="rgba(255,255,255,0.35)" strokeWidth="1.5"/>
                <rect x="10" y="10" width="76" height="46" rx="3" fill="rgba(255,255,255,0.08)"/>
                <rect x="14" y="14" width="40" height="5" rx="2" fill="rgba(255,255,255,0.4)"/>
                <rect x="14" y="23" width="55" height="3" rx="1.5" fill="rgba(255,255,255,0.2)"/>
                <rect x="14" y="29" width="45" height="3" rx="1.5" fill="rgba(255,255,255,0.2)"/>
                <rect x="14" y="35" width="50" height="3" rx="1.5" fill="rgba(255,255,255,0.2)"/>
                <rect x="40" y="62" width="16" height="5" rx="1" fill="rgba(255,255,255,0.2)"/>
                <rect x="2" y="67" width="92" height="4" rx="2" fill="rgba(255,255,255,0.15)"/>
                <circle cx="120" cy="33" r="16" fill="rgba(255,255,255,0.15)" stroke="rgba(255,255,255,0.4)" strokeWidth="1.5"/>
                <line x1="104" y1="26" x2="96" y2="26" stroke="rgba(255,255,255,0.6)" strokeWidth="1.5" strokeLinecap="round"/>
                <line x1="136" y1="26" x2="144" y2="26" stroke="rgba(255,255,255,0.6)" strokeWidth="1.5" strokeLinecap="round"/>
                <polyline points="96,26 92,33 96,40" fill="none" stroke="rgba(255,255,255,0.6)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                <polyline points="144,26 148,33 144,40" fill="none" stroke="rgba(255,255,255,0.6)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                <circle cx="120" cy="33" r="5" fill="rgba(255,255,255,0.9)"/>
                <rect x="148" y="4" width="88" height="58" rx="6" fill="rgba(255,255,255,0.12)" stroke="rgba(255,255,255,0.35)" strokeWidth="1.5"/>
                <rect x="154" y="10" width="76" height="46" rx="3" fill="rgba(255,255,255,0.08)"/>
                <rect x="158" y="14" width="40" height="5" rx="2" fill="rgba(255,255,255,0.4)"/>
                <rect x="158" y="23" width="55" height="3" rx="1.5" fill="rgba(255,255,255,0.2)"/>
                <rect x="158" y="29" width="45" height="3" rx="1.5" fill="rgba(255,255,255,0.2)"/>
                <rect x="158" y="35" width="50" height="3" rx="1.5" fill="rgba(255,255,255,0.2)"/>
                <rect x="184" y="62" width="16" height="5" rx="1" fill="rgba(255,255,255,0.2)"/>
                <rect x="146" y="67" width="92" height="4" rx="2" fill="rgba(255,255,255,0.15)"/>
                <text x="48" y="88" textAnchor="middle" fill="rgba(255,255,255,0.85)" fontSize="10" fontFamily="sans-serif">Vous</text>
                <text x="192" y="88" textAnchor="middle" fill="rgba(255,255,255,0.85)" fontSize="10" fontFamily="sans-serif">Technicien CPUc</text>
              </svg>

              <div style={{ borderTop: '0.5px solid rgba(255,255,255,0.25)', paddingTop: '1.1rem' }}>
                <p style={{ margin: '0 0 6px', fontSize: '0.7rem', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.12em', color: 'rgba(255,255,255,0.75)' }}>
                  Pas d'agent installé ?
                </p>
                <p style={{ margin: '0 0 12px', fontSize: '1rem', fontWeight: 700, color: '#fff', lineHeight: 1.4 }}>
                  On peut quand même<br />vous dépanner.
                </p>
                <p style={{ margin: '0 0 20px', fontSize: '0.82rem', color: 'rgba(255,255,255,0.85)', lineHeight: 1.6 }}>
                  On vous envoie un accès temporaire —<br />aucune installation préalable requise.
                </p>
              </div>

              <div className="d-flex flex-row gap-2 w-100">
                {/* Windows */}
                <a
                  href="https://cloudbuild.splashtop.com/F589B48DF01F523C5E222D77F5650F7E/PARJ7KRHJ7R7/13f4b7ec94100826961b8df25761ff80/3.8.6.1/SplashtopSOS_Win_v3.8.6.1_PARJ7KRHJ7R7_n.exe"
                  target="_blank"
                  rel="noreferrer"
                  className="btn btn-lg rounded-pill px-3"
                  style={{
                    flex: 1,
                    background: '#fff',
                    color: 'var(--cpuc-red)',
                    fontWeight: 700,
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '8px',
                    whiteSpace: 'nowrap',
                    boxShadow: '0 0 0 3px rgba(255,255,255,0.25), 0 8px 24px rgba(0,0,0,0.25)',
                    transition: 'box-shadow 0.25s ease, transform 0.2s ease',
                  }}
                  onMouseEnter={e => {
                    e.currentTarget.style.boxShadow = '0 0 0 5px rgba(255,255,255,0.45), 0 12px 32px rgba(0,0,0,0.35)';
                    e.currentTarget.style.transform = 'translateY(-2px)';
                  }}
                  onMouseLeave={e => {
                    e.currentTarget.style.boxShadow = '0 0 0 3px rgba(255,255,255,0.25), 0 8px 24px rgba(0,0,0,0.25)';
                    e.currentTarget.style.transform = 'translateY(0)';
                  }}
                >
                  <i className="bi bi-windows"></i>
                  Windows
                </a>

                {/* macOS */}
                <a
                  href="https://cloudbuild.splashtop.com/F589B48DF01F523C5E222D77F5650F7E/PARJ7KRHJ7R7/13f4b7ec94100826961b8df25761ff80/3.8.6.0/SplashtopSOS_Mac_v3.8.6.0_PARJ7KRHJ7R7_n.dmg"
                  target="_blank"
                  rel="noreferrer"
                  className="btn btn-lg rounded-pill px-3"
                  style={{
                    flex: 1,
                    background: 'rgba(255,255,255,0.15)',
                    color: '#fff',
                    fontWeight: 700,
                    border: '1.5px solid rgba(255,255,255,0.4)',
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '8px',
                    whiteSpace: 'nowrap',
                    boxShadow: '0 0 0 3px rgba(255,255,255,0.1), 0 8px 24px rgba(0,0,0,0.15)',
                    transition: 'box-shadow 0.25s ease, transform 0.2s ease, background 0.2s ease',
                  }}
                  onMouseEnter={e => {
                    e.currentTarget.style.background = 'rgba(255,255,255,0.25)';
                    e.currentTarget.style.boxShadow = '0 0 0 5px rgba(255,255,255,0.2), 0 12px 32px rgba(0,0,0,0.25)';
                    e.currentTarget.style.transform = 'translateY(-2px)';
                  }}
                  onMouseLeave={e => {
                    e.currentTarget.style.background = 'rgba(255,255,255,0.15)';
                    e.currentTarget.style.boxShadow = '0 0 0 3px rgba(255,255,255,0.1), 0 8px 24px rgba(0,0,0,0.15)';
                    e.currentTarget.style.transform = 'translateY(0)';
                  }}
                >
                  <i className="bi bi-apple"></i>
                  macOS
                </a>
              </div>

              <p style={{ margin: '10px 0 0', color: 'rgba(255,255,255,0.7)', fontSize: '0.75rem' }}>
                Un technicien vous guide à chaque étape
              </p>
            </div>

          </div>
        </div>

        <div className="row g-4 mt-4">
          <div className="col-md-4" data-aos="fade-up" data-aos-delay="0">
            <div className="service-card p-4 text-center h-100">
              <div className="service-icon mx-auto mb-3"><i className="bi bi-broadcast"></i></div>
              <h3 className="h6 fw-bold">Surveillance en temps réel</h3>
              <p className="text-secondary small mb-0">Vos systèmes surveillés en continu pour une performance optimale.</p>
            </div>
          </div>
          <div className="col-md-4" data-aos="fade-up" data-aos-delay="100">
            <div className="service-card p-4 text-center h-100">
              <div className="service-icon mx-auto mb-3"><i className="bi bi-laptop"></i></div>
              <h3 className="h6 fw-bold">Support à distance</h3>
              <p className="text-secondary small mb-0">Notre équipe prend le contrôle à distance de votre poste pour régler votre problème rapidement, sans déplacement.</p>
            </div>
          </div>
          <div className="col-md-4" data-aos="fade-up" data-aos-delay="200">
            <div className="service-card p-4 text-center h-100">
              <div className="service-icon mx-auto mb-3"><i className="bi bi-clock-history"></i></div>
              <h3 className="h6 fw-bold">Réactivité garantie</h3>
              <p className="text-secondary small mb-0">Une équipe disponible pour vos urgences et vos projets, sans vous laisser attendre.</p>
            </div>
          </div>
        </div>

      </div>
    </section>
  );
}